import React from 'react';
import { Order, OrderStatus } from '../../pages/Orders';
import { OrderCard } from './OrderCard';
interface OrderBoardProps {
  groupedOrders: Record<OrderStatus, Order[]>;
  orderStatuses: Array<{
    id: string;
    name: string;
    description: string;
  }>;
  onOrderClick: (order: Order) => void;
  onOrderMove: (orderId: string, newStatus: OrderStatus) => void;
}
export function OrderBoard({
  groupedOrders,
  orderStatuses,
  onOrderClick,
  onOrderMove
}: OrderBoardProps) {
  // Handle drag start
  const handleDragStart = (e: React.DragEvent, order: Order) => {
    e.dataTransfer.setData('orderId', order.id);
  };
  // Handle drop
  const handleDrop = (e: React.DragEvent, status: OrderStatus) => {
    e.preventDefault();
    const orderId = e.dataTransfer.getData('orderId');
    onOrderMove(orderId, status);
  };
  // Handle drag over
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };
  return <div className="flex overflow-x-auto pb-4" data-id="element-1303">
      {orderStatuses.map(status => <div key={status.id} className="flex-shrink-0 w-80 mx-2 first:ml-4 last:mr-4" data-id="element-1304">
          <div className="bg-gray-50 rounded-t-lg p-3" data-id="element-1305">
            <h3 className="font-medium text-gray-900" data-id="element-1306">{status.name}</h3>
            <p className="text-sm text-gray-500" data-id="element-1307">{status.description}</p>
            <div className="mt-1 text-xs text-gray-500" data-id="element-1308">
              {groupedOrders[status.id as OrderStatus]?.length || 0} orders
            </div>
          </div>
          <div className="bg-gray-50 min-h-[500px] p-2 rounded-b-lg" onDrop={e => handleDrop(e, status.id as OrderStatus)} onDragOver={handleDragOver} data-id="element-1309">
            {groupedOrders[status.id as OrderStatus]?.map(order => <div key={order.id} className="mb-2 cursor-move" draggable onDragStart={e => handleDragStart(e, order)} onClick={() => onOrderClick(order)} data-id="element-1310">
                <OrderCard order={order} compact data-id="element-1311" />
              </div>)}
            {groupedOrders[status.id as OrderStatus]?.length === 0 && <div className="h-20 border border-dashed border-gray-300 rounded-lg flex items-center justify-center" data-id="element-1312">
                <p className="text-sm text-gray-500" data-id="element-1313">Drop orders here</p>
              </div>}
          </div>
        </div>)}
    </div>;
}